/*
THIS INFRAGISTICS ULTIMATE SOFTWARE LICENSE  AGREEMENT ("AGREEMENT") LOCATED HERE:
https://www.infragistics.com/legal/license/igultimate-la
https://www.infragistics.com/legal/license/igultimate-eula
GOVERNS THE LICENSING, INSTALLATION AND USE OF INFRAGISTICS SOFTWARE. BY DOWNLOADING AND/OR INSTALLING AND USING INFRAGISTICS SOFTWARE: you are indicating that you have read and understand this Agreement, and agree to be legally bound by it on behalf of the yourself and your company.
*/
import { IgrGridCellPosition } from './igr-grid-cell-position';
import { GridCellPosition } from './GridCellPosition';
import { TypeRegistrar } from "igniteui-react-core";
var IgrGridCellPositionModule = /** @class */ /*@__PURE__*/ (function () {
    function IgrGridCellPositionModule() {
    }
    IgrGridCellPositionModule.register = function () {
        TypeRegistrar.registerCons("IgrGridCellPosition", IgrGridCellPosition);
        TypeRegistrar.register("GridCellPosition", GridCellPosition.$type);
    };
    return IgrGridCellPositionModule;
}());
export { IgrGridCellPositionModule };
//# sourceMappingURL=igr-grid-cell-position-module.js.map
